import { ReferenceRequestPayload } from 'features/Connect/features/ConnectATSIntegration/HiringRequests/components/CandidateFeedback/components/Panes/Create/Reference/LandingPage/mutations';
import { BaseNimbleAPI } from './baseAPI';

class ReferenceRequestsAPI extends BaseNimbleAPI {
  get config() {
    return { baseURL: '/api/reference_requests' };
  }

  async getRequests(candidateId: number) {
    const response = await this.get(`/${candidateId}/`);
    return response.data;
  }

  async postRequest(candidateId: number, formData: ReferenceRequestPayload) {
    const response = await this.post(`/${candidateId}/`, formData);
    return response.data;
  }
}

export default new ReferenceRequestsAPI();
